// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { CurrencyProvider } from './contexts/CurrencyContext';
import MainPage from './pages/MainPage';
import InvoicePage from './pages/InvoicePage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import CancellationPage from './pages/CancellationPage';

function App() {
  return (
    <LanguageProvider>
      <CurrencyProvider>
        <Router>
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/invoice" element={<InvoicePage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/cancellation" element={<CancellationPage />} />
          </Routes>
        </Router>
      </CurrencyProvider>
    </LanguageProvider>
  );
}

export default App;